import { Button, Checkbox, Col, Form, Input, message, Row, Flex, Space, Select, Popconfirm, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { dictsGetUsers } from "../../extensions/dicts"
import { isMobile } from "../../extensions/design";
import dayjs from "dayjs";
import { LogMonitor } from "@/controls";

const ClientAbonItemMain = ({ saleId, onAbonsUpdate }) => {
  const [form] = Form.useForm();
  const [itemAbon, setItemAbon] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAbonPaid, setIsAbonPaid] = useState(false);
  const [product, setProduct] = useState(null);

  const getProduct = (productId) => {
    if (!productId) {
      setProduct(null);
      return;
    }
    serverFetch(`product/${productId}`)
      .then((data) => setProduct(data))
      .catch((e) => message.error(e.userMessage));
  };

  const getData = () => {
    setLoading(true);
    serverFetch(`sale/${saleId}`)
      .then((data) => {
        if (data.finish) data.finish = dayjs(data.finish);
        form.setFieldsValue(data);
        setItemAbon(data);
        setIsAbonPaid(parseFloat(data.paid) > 0) 
        setLoading(false); 
        getProduct(data.productId);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userName);
      });
  };
  useEffect(getData, []);

  const onSave = () => {
    setLoading(true);
    serverFetch("sale", {
      method: "PUT",
      bodyData: itemAbon,
    })
      .then(() => {
        onAbonsUpdate();
        setLoading(false);
        message.success("Успешно");
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };
  const onDelete = () => {
    setLoading(true);
    serverFetch(`sale/${itemAbon.id}`, {
      method: "DELETE",
    })
      .then(() => {
        onAbonsUpdate(true);
        setLoading(false);
        message.success("Успешно");
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };
  const safeNumber = (val) => {
    if (val === null || val === undefined) return 0;
    if (val === "" || val === "-") return 0;
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  };

  const onValuesChange = (value) => {
    const { visitQty, ...rest } = value;

    let newItem = { ...itemAbon, ...rest };

    if ("initialVisitQty" in rest) {
      const oldInitial = safeNumber(itemAbon.initialVisitQty);
      const newInitial = safeNumber(rest.initialVisitQty);

      const diff = newInitial - oldInitial;

      const oldVisitQty = safeNumber(itemAbon.visitQty);
      const newVisitQty = oldVisitQty - diff; // увеличиваем или уменьшаем

      newItem.visitQty = newVisitQty;
    }

    if ("discountPrc" in rest || "price" in rest) {
      const discount = parseFloat(newItem.discountPrc || 0);
      const price = parseFloat(newItem.price || 0);
      const discountAmount = (price * discount) / 100;
      newItem.syma = price - discountAmount;
    }
    form.setFieldsValue(newItem);
    setItemAbon(newItem);
  };


  useEffect(() => {
    dictsGetUsers(setUsers)
  }, []); 

  const content = !isMobile ? [
  <Form form={form} disabled={loading} onValuesChange={onValuesChange} colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }}>
    <Form.Item><b>Основная информация</b></Form.Item>
    <Form.Item label="Комментарий" name="comment"><Input/></Form.Item>
    <Row>
      <Col span={11}>
        <Form.Item label="Остаток посещений" labelCol={{ span: 13 }} wrapperCol={{ span: 10 }} shouldUpdate={(prev, curr) => prev.visitQty !== curr.visitQty}>
          {({ getFieldValue }) => {
            const value = getFieldValue("visitQty");
            return <Input disabled value={value === -1 ? "Неограничен" : value} />;
          }}
        </Form.Item>
      </Col>
      <Col span={13}>
        <Form.Item label="Нач. Остаток" name="initialVisitQty" labelCol={{ span: 16 }} wrapperCol={{ span: 8 }}>
          <Input disabled={product?.vid === 3} placeholder="Неограничен" />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span={11}>{" "}<Form.Item label="Сумма без скидки" name="price" labelCol={{ span: 13 }} wrapperCol={{ span: 10 }}><Input type="number" disabled/></Form.Item></Col>
      <Col span={6}>{" "}<Form.Item label="Скидка %" name="discountPrc" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Input type="number" disabled={isAbonPaid}/></Form.Item></Col>
      <Col span={7}>{" "}<Form.Item label="Сумма" name="syma" labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}><Input type="number" disabled/></Form.Item></Col>
    </Row>
    <Form.Item label="Исполнитель" name="userId"><Select options={users}/></Form.Item>
    <Form.Item className="sport-modal-group-item">
      <Row>
        <Col span={7}><Form.Item valuePropName="checked" name="blocked"><Checkbox>Заблокировано</Checkbox></Form.Item></Col>
        <Col span={17}><Form.Item label="Причина" name="blockCause"><Input /></Form.Item></Col>
      </Row>
    </Form.Item>
    <Flex justify="space-between">
      <Form.Item valuePropName="checked" name="deleted"><Checkbox disabled>Удален</Checkbox></Form.Item>
      <Space>
      <LogMonitor vid={4} id={itemAbon.id}/>
      <Popconfirm title="Подтверждение" description={!itemAbon.deleted ? "Вы действительно хотите удалить продажу?" : "Вы действительно хотите отменить удаление абонемента?"} onConfirm={onDelete}>
        <Button className="sport-btn">Удалить</Button>
      </Popconfirm>
      <Button className="sport-btn" onClick={onSave}>Сохранить</Button>
      </Space>
    </Flex>
  </Form>
  ] : [
  <Form form={form} disabled={loading} onValuesChange={onValuesChange} colon={false} labelCol={{ flex: "100px" }} wrapperCol={{ flex: "1" }}>
    <Form.Item label="Окончание" name="finish">
      <DatePicker disabled format="DD.MM.YYYY" placeholder="" className="client-abon-form-item"/>
    </Form.Item>
    <Form.Item label="Комментарий" name="comment">
      <Input className="client-abon-form-item"/>
    </Form.Item>
    <div className="client-item-line-double-halfed">
      <Form.Item label="Остаток посещений" shouldUpdate={(prev, curr) => prev.visitQty !== curr.visitQty}>
        {({ getFieldValue }) => {
          const value = getFieldValue("visitQty");
          return <Input disabled value={value === -1 ? "Неогр." : value} />;
        }}
      </Form.Item>
      <Form.Item label="Скидка %" name="discountPrc" labelCol={{ flex: "70px" }} wrapperCol={{ flex: "1" }}>
        <Input type="number" disabled={isAbonPaid}/>
      </Form.Item>
    </div>
    <div className="client-item-line-double-halfed">
      <Form.Item label="Сумма без скидки" name="price">
        <Input type="number" disabled/>
      </Form.Item>
      <Form.Item label="Сумма" name="syma" labelCol={{ flex: "70px" }} wrapperCol={{ flex: "1" }}>
        <Input type="number" disabled/>
      </Form.Item>
    </div>
    <Form.Item label="Исполнитель" name="userId">
      <Select className="client-abon-form-item" options={users}/>
    </Form.Item>
    <div className="client-item-line-double-floated">
      <Form.Item valuePropName="checked" name="blocked">
        <Checkbox>
          <span style={{fontSize:"12px"}}>Заблокир.</span>
        </Checkbox>
      </Form.Item>
      <Form.Item label="Причина" name="blockCause" labelCol={{ flex: "70px" }} wrapperCol={{ flex: "1" }}>
        <Input />
      </Form.Item>
    </div>
    <Form.Item valuePropName="checked" name="deleted">
      <Checkbox disabled>
        <span style={{fontSize:"12px"}}>Удален</span>
      </Checkbox>
      </Form.Item>
    <div className="client-item-line-double-halfed">
      <LogMonitor vid={4} id={itemAbon.id}/>
      <Popconfirm title="Подтверждение" description={!itemAbon.deleted ? "Вы действительно хотите удалить продажу?" : "Вы действительно хотите отменить удаление абонемента?"} onConfirm={onDelete}
        placement="top" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
        <Button>Удалить</Button>
      </Popconfirm>
      <Button onClick={onSave}>Сохранить</Button>
    </div>
  </Form>
  ]

  return (
    <>
      {content}
    </>
  );
};

export default ClientAbonItemMain;
